import React from 'react';

import './AvailableMeals.css'
import Card from "../UI/Card";
import MealItems from "./MealItem/MealItems";


function AvailableMeals() {

    const DUMMY_MEALS = [
        {
            id: 'm1',
            name: 'SUNCHOKE SALAD',
            description: 'Roasted sunchokes, rosemary fennel, marinated artichokes, ' +
                'crispy sunchoke chips, goat cheese crumble, ' +
                'kale & arugula perfectly paired with meyer lemon vinaigrette',
            price: 22.99,
        },
        {
            id: 'm2',
            name: 'SANTA FE SALAD',
            description: 'avocado, corn, jack & cheddar, grape tomatoes, onions, tortilla chips, kale & romaine, ' +
                'perfectly paired with chipotle-lime vinaigrette & a fresh lime squeeze',
            price: 20.99,
        },
        {
            id: 'CALI COBB SALAD',
            name: 'Barbecue Burger',
            description: 'roasted turkey, crispy bacon, mushrooms, crumbled blue cheese, grape tomatoes, cucumbers, ' +
                'baby spinach & romaine, perfectly paired with buttermilk ranch dressing',
            price: 19.99,
        },
        {
            id: 'm4',
            name: 'FALAFEL SALAD',
            description: 'falafel, scallions, grape tomatoes, cucumbers, carrots, chickpeas, kale & romaine, perfectly ' +
                'paired with lemon tahini dressing & a splash of house-made hot sauce',
            price: 18.99,
        },

        {
            id: 'm5',
            name: 'MEXICAN CAESAR SALAD',
            description: 'avocado, pico de gallo, cotija cheese, fiery pickled sweet peppers, crushed pita chips, ' +
                'romaine, perfectly paired with mexican pepita caesar',
            price: 15.99,
        },

        {
            id: 'm6',
            name: 'SOUTH BEACH SALAD',
            description: 'craisins, walnuts, green apples, crumbled blue cheese, mesclun & romaine, perfectly paired with balsamic vinaigrette',
            price: 18.99,
        },
    ];

    const mealList = DUMMY_MEALS.map(meal =>
        <MealItems key={ meal.id }
                   id={ meal.id }
                   name={ meal.name }
                   description={ meal.description }
                   price={ meal.price }/>);

    return (
        <section className="meals">

            <Card>
                <ul>{ mealList }</ul>
            </Card>


        </section>
    )
}

export default AvailableMeals;